import { MeteredQuote } from "use-smart-locks-shared";
import { useMeteredQuoteQuery } from "../queries/use-metered-quote-query";

export const useMeteredQuote = (unitId: string): MeteredQuote => {
  const { data } = useMeteredQuoteQuery(unitId);

  return data;
};
